import { CountUp } from 'countup.js'

const widgetToken = document.currentScript.dataset.widgetId
let countUp

const fetchImpact = async () => {
  const url = `/widgets/impact/${widgetToken}.json`
  try {
    const response = await fetch(url, { headers: { Accept: 'application/json' } })
    return await response.json()
  }
  // Non-essential impact figures polled every 30s — a blank/truncated
  // response (empty body → "Unexpected end of JSON input") or a network
  // blip is fine to skip. Swallow it so it doesn't surface as an unhandled
  // rejection, but log for debugging if a real failure ever shows up here.
  catch (error) {
    console.error('Failed to load impact data:', error)
  }
}

const refreshImpact = async () => {
  const data = await fetchImpact()
  if (data) countUp.update(data.amount)
}

const initImpact = async () => {
  const impactAmount = document.getElementById('home-impact-amount')
  const impactDesc = document.getElementById('home-impact-desc')

  const data = await fetchImpact()
  if (data) {
    countUp = new CountUp(impactAmount, data.amount * 1, {
      prefix: data.currency_symbol,
      startVal: data.amount * 0.95,
    })
    if (countUp.error)
      console.error(countUp.error)
    else {
      countUp.start()
      if (impactDesc) {
        impactDesc.textContent = data.description
        impactDesc.style.opacity = 1
      }
      impactAmount.style.opacity = 1
      setInterval(refreshImpact, 30000)
    }
  }
}

document.addEventListener('DOMContentLoaded', initImpact)
